import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/sxMaterial/page',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function delObj (id) {
  return axios({
    url: `/sxMaterial/${id}`,
    method: 'DELETE'
  })
}
export function getObj (id) {
  return axios({
    url: `/sxMaterial/${id}`,
    method: 'GET'
  })
}
export function addObj (params) {
  return axios({
    url: `/sxMaterial/save`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
export function putObj (params) {
  return axios({
    url: `/sxMaterial/update`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
